import { create } from 'zustand'

interface ChatStore {
  isOpen: boolean
  onClose: () => void
  onOpen: () => void
  onToggle: () => void
}

export const useChat = create<ChatStore>((set) => {
  return {
    isOpen: !!process.env.NEXT_PUBLIC_CHAT_DEFAULT_VALUE || false,
    onOpen: () => set({ isOpen: true }),
    onClose: () => set({ isOpen: false }),
    onToggle: () => set((state) => ({ isOpen: !state.isOpen })),
  }
})
